import React from 'react';
import { useLocation } from 'react-router-dom';

function SuccessPage() {
  const location = useLocation();
  const message = location.state?.message || "✅ PDF generated successfully. Please check your downloads folder.";

  return (
    <div className="center-text">
      <h1>
        <span role="img" aria-label="party popper">🎉</span> Submission Complete
      </h1>
      <p>{message}</p>
      <a href="/">Return Home</a>
    </div>
  );
}

export default SuccessPage;
